import React, { useEffect, useState } from 'react';
import { connect, ResolveThunks } from 'react-redux';
import { AppState } from '../store/store';
import { fetchPerson } from './amlActions';
import { Card, Spinner as ReactSpinner } from 'react-bootstrap';
import { clearPersonState } from './amlReducer';
import PersonInfo from './PersonInfo';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import { isCounterparty } from '../common/helper';
import SalvPage from '../common/SalvPage';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-solid-svg-icons';
import InternalLink from '../common/InternalLink';
import { counterpartyDashboardLink } from '../dashboard/dashboardHelpers';
import { useMe } from '../organisation/useMe';
import { isFeatureEnabled, ORGANISATION_FEATURE } from '../organisation/feature/helper';
import { InternalNavigation } from '../navigation/helper';

export const Person = ({ fetchPerson, clearPersonState, person }: Props) => {
  const { id } = useParams<{ id: string }>();
  const [fetching, setFetching] = useState(true);

  useEffect(() => {
    if (!id) {
      clearPersonState();
    }
  }, [id, clearPersonState]);

  useEffect(() => {
    if (id) {
      setFetching(true);
      fetchPerson(id).finally(() => {
        setFetching(false);
      });
    }

    return () => {
      clearPersonState();
    };
  }, [id, fetchPerson, clearPersonState]);

  const { features } = useMe();
  const isCounterpartyDashboardEnabled = isFeatureEnabled(
    ORGANISATION_FEATURE.PERSON_PAGE_COUNTERPARTY_DASHBOARD,
    features
  );

  return (
    <SalvPage
      title={isCounterparty(person || undefined) ? 'Counterparty' : 'Customer'}
      subTitle={
        isCounterpartyDashboardEnabled &&
        person &&
        isCounterparty(person) && (
          <InternalLink
            title={
              <>
                <FontAwesomeIcon icon={faArrowUpRightFromSquare} className='me-2' />
                Go to dashboard
              </>
            }
            link={counterpartyDashboardLink(person.id)}
          />
        )
      }
    >
      {person === null ? (
        fetching ? (
          <Card>
            <Card.Body>
              <div className='small'>Loading ...</div>
              <ReactSpinner className='loader-spinner' animation='border' role='status'>
                <span className='visually-hidden'>Loading...</span>
              </ReactSpinner>
            </Card.Body>
          </Card>
        ) : (
          <Card>
            <Card.Body>
              <div className='small'>
                Could not find person with ID: {id}. Try{' '}
                <Link to={InternalNavigation.personSearch}>customers search</Link>.
              </div>
            </Card.Body>
          </Card>
        )
      ) : (
        <PersonInfo person={person} />
      )}
    </SalvPage>
  );
};

export const mapStateToProps = ({ aml }: AppState) => ({
  ...aml,
});

export const mapDispatchToProps = {
  fetchPerson,
  clearPersonState,
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export default connect(mapStateToProps, mapDispatchToProps)(Person);
